import React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { TablePagination } from '@material-ui/core';
import axios from 'axios';
import { useState, useEffect } from 'react';
import { CommonConfig } from '../../config/common-config';
import useStyles from '../menubar/menubarStyle';
import moment from 'moment';

export default function Leads() {
    const [leads, setLeads] = useState([]);
    const [page, setPage] = useState(0);
    const [total, setTotal] = useState(0);
    const classes = useStyles();
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const getAllLeads = async (newPage, pageSize) => {
        try {
            const response = await axios.get(`${CommonConfig.dev.appUrl}/api/contact_us_form?page=${newPage}&pageSize=${rowsPerPage}`);
            // .get(`${CommonConfig.dev.baseUrl}/api/auth/getservice-byemployeeid/advith?page=0&size=10&sort=serviceId,desc`, tokens)
            setLeads(response?.data?.data);
            setTotal(response?.data.total);
        } catch (error) {}
    };
    useEffect(() => {
        getAllLeads(page + 1, rowsPerPage);
    }, [page, rowsPerPage]);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
        getAllLeads(newPage + 1, rowsPerPage);
    };

    const handleChangeRowsPerPage = (event) => {
        const newRowsPerPage = parseInt(event.target.value, 10);
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
        getAllLeads(page + 1, newRowsPerPage);
    };

    return (
        <>
            <TableContainer component={Paper}>
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                    <TableHead>
                        <TableRow>
                            <TableCell>ID</TableCell>
                            <TableCell>Name</TableCell>
                            <TableCell>Email</TableCell>
                            <TableCell>Phone</TableCell>
                            <TableCell>Message</TableCell>
                            <TableCell>Date</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {leads?.map((row) => (
                            <TableRow key={row.id} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                <TableCell>{row.id}</TableCell>
                                <TableCell>{row.fullName}</TableCell>
                                <TableCell>{row.email}</TableCell>
                                <TableCell>{row.phoneNumber}</TableCell>
                                <TableCell>{row.message}</TableCell>
                                <TableCell>{moment(row.createdAt).format('DD-MM-YYYY HH:MM')}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
                <TablePagination
                    component="div"
                    count={total}
                    page={page}
                    onChangePage={handleChangePage}
                    rowsPerPage={rowsPerPage}
                    onChangeRowsPerPage={handleChangeRowsPerPage}
                />
            </TableContainer>
        </>
    );
}
